import { selectCurrentHotelId } from 'accessors'
import BookingListDialog from 'features/Analytics/BookingListDialog'
import BookingHistory from 'features/BookingDetails/BookingHistory'
import BookingDetailsDialog from 'features/BookingDetailsDialog'
import useFirstRender from 'hooks/useFirstRender'
import usePlausible from 'hooks/usePlausible'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import performanceReportsApi from 'services/api/performanceReports'

const RegainedGuestResults = ({ category, fromDate, toDate, kind, onClose, segment }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState()
  const [stats, setStats] = useState({
    bookingsTotal: 100
  })

  const [activeSubscriberId, setActiveSubscriberId] = useState()

  const [activeBookingId, setActiveBookingId] = useState()

  const [bookings, setBookings] = useState([])

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  useEffect(() => {
    setIsLoading(true)

    performanceReportsApi.lost.segmentations
      .breakdown({
        segmentRange: segment,
        fromDate,
        toDate,
        kind
      })
      .then(data => {
        setStats({
          bookingsTotal: data.bookingsTotal,
          bookingsTotalRate: data.bookingsTotalRate,
          deliveriesTotal: data.deliveriesTotal,
          deliveriesSent: data.deliveriesSent
        })

        setBookings(data.bookingViews)
        setIsErred(false)
      })
      .catch(() => {
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [fromDate, toDate, segment, kind])

  const { postEvent, plausibleEvents } = usePlausible()

  useFirstRender(() => {
    postEvent(plausibleEvents.ViewRegainedLostGuestSegment, {
      category
    })
  }, [postEvent, plausibleEvents, category])

  if (activeSubscriberId) {
    return (
      <BookingHistory
        subscriberId={activeSubscriberId}
        onClose={() => setActiveSubscriberId(null)}
      />
    )
  }

  if (activeBookingId) {
    return (
      <BookingDetailsDialog
        bookingId={activeBookingId}
        onClose={() => setActiveBookingId(null)}
      />
    )
  }

  return (
    <BookingListDialog
      currentSubsidiaryId={currentSubsidiaryId}
      onClose={onClose}
      isLoading={isLoading}
      isErred={isErred}
      category={category}
      stats={stats}
      bookings={bookings}
      setActiveSubscriberId={setActiveSubscriberId}
      setActiveBookingId={setActiveBookingId}
      version="RegainedLostGuests"
      isPaginated={false}
    />
  )
}

export default RegainedGuestResults
